import { render } from "./SVGPlus.vue?vue&type=template&id=64d1c584&scoped=true&ts=true"
import script from "./SVGPlus.vue?vue&type=script&lang=ts"
export * from "./SVGPlus.vue?vue&type=script&lang=ts"

import "./SVGPlus.vue?vue&type=style&index=0&id=64d1c584&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d1c584"]])

export default __exports__